module.exports = __webpack_public_path__ + "assets/img/img_6_6.0b4fc976.png";